import React from "react";
import {
  Button,
  ButtonGroup,
  ButtonToolbar,
  Container,
  ToggleButton,
  ToggleButtonGroup,
} from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";
import update from "immutability-helper";

import SearchBox from "../../../Components/Input/SearchBox";
import ItemList from "../../Components/ItemList";
import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import { getFullName } from "../../../Modules/utils/fullname";
import api from "../../../Services/Api/api";
import EditAccount from "./EditAccount";
import NavBar from "../../Components/NavBar";
import AccountDetails from "./AccountDetails";
import navigationModule from "../../../Modules/navigation/navigationModule";
import withRouter from "../../../Components/wrappers/with-router";
import RenderAmount from "../../../Components/etc/RenderAmount";
import { isMobile } from "react-device-detect";
import PrintCustomerReceipt from "./PrintCustomerReceipt";

const SCREEN_NAME = "ACCOUNTS_SCREEN";

class AccountsScreen extends AppComponent {
  state = {
    visibleModal: null,
    modalData: null,
    triggerReload: 0,
    triggerLoadMore: 0,
  };

  additionalQueries = null;

  columns = [
    {
      value: "shortId",
      label: "ID",
    },
    {
      value: "accountType",
      label: "Account Type",
      render: ({ item }) => _.startCase(item.accountType),
    },
    {
      value: "name",
      label: "Name",
      render: ({ item }) => getFullName(item.customer),
    },
    {
      value: "balance",
      label: "Balance",
      render: ({ item }) => <RenderAmount value={item.balance?.toFixed?.(2)} />,
    },
    {
      value: "interestRate",
      label: "Interest Rate",
      render: ({ item }) => <div className="numeric">{item.interestRate}%</div>,
      // hideInMobile: true,
    },
    {
      value: "period",
      label: "Period",
      render: ({ item }) =>
        _.startCase(
          item.accountType === "deposit"
            ? item.depositInterval
            : item.interestPeriod
        ),
      // hideInMobile: true,
    },
    {
      value: "openingDate",
      label: "Opening Date",
      render: ({ item }) =>
        new Date(
          item.accountType === "deposit" ? item.openingDate : item.createdAt
        ).toLocaleDateString(),
      hideInMobile: true,
    },
    {
      value: "endingDate",
      label: "Ending Date",
      render: ({ item }) =>
        item.endingDate ? new Date(item.endingDate).toLocaleDateString() : null,
      hideInMobile: true,
    },
    {
      value: "closed",
      label: "Status",
      render: ({ item }) => (item.closed ? "Closed" : "Open"),
    },
    {
      value: "note",
      label: "Note",
      render: ({ item }) =>
        item.note?.length > 15 ? item.note.substr(0, 15) + "..." : item.note,
      hideInMobile: true,
    },
    {
      value: "actions",
      label: "Actions",
      render: ({ item, index }) => (
        <div style={{ textAlign: "center" }}>
          <Button
            size="sm"
            variant="secondary"
            onClick={(e) => {
              e.stopPropagation();
              this.setAsyncState({
                visibleModal: "editAccount",
                modalData: { account: item },
              });
            }}
          >
            Edit
          </Button>{" "}
          {/* <div className="m-1" /> */}
          <Button
            size="sm"
            variant="secondary"
            disabled={!item?._id}
            onClick={(e) => {
              e.stopPropagation();
              this.setAsyncState({
                visibleModal: "customerReceipt",
                modalData: { account: item, index },
              });
            }}
          >
            Receipt
          </Button>
        </div>
      ),
    },
  ].filter((x) => (isMobile ? !x.hideInMobile : true));

  handleSearchQ(q) {
    if (q) {
      this.additionalQueries = {
        customerQuery: {
          select: "_id",
          limit: 1000,
          where: {
            $and: [
              {
                $or: [
                  {
                    fullName: { $regex: q, $options: "i" },
                  },
                  {
                    phone: { $regex: q, $options: "i" },
                  },
                  {
                    email: { $regex: q, $options: "i" },
                  },
                ],
              },
            ],
          },
        },
      };
    } else {
      this.additionalQueries = null;
    }
    this.setAsyncState({ triggerReload: Date.now() });
  }

  searchAccountId(q) {
    this.setAdditionalFilter("shortId", q || undefined);
  }

  setAdditionalFilter(key, value) {
    if (value !== undefined) {
      this.setAsyncState({
        triggerReload: Date.now(),
        additionalFilter: update(this.state.additionalFilter || {}, {
          $merge: { [key]: value },
        }),
      });
    } else {
      this.setAsyncState({
        triggerReload: Date.now(),
        additionalFilter: update(this.state.additionalFilter || {}, {
          $unset: [key],
        }),
      });
    }
  }

  async retriveData(query) {
    const { accounts } = await api.get("v1/account", query);
    return accounts;
  }

  async setItems(items) {
    this.props.setScreenState({ accounts: items });
  }

  async onNewAccount(item) {
    await this.setAsyncState({
      visibleModal: null,
      modalData: null,
      triggerReload: Date.now(),
    });

    await this.onRowClick({ item, index: -1 });
  }

  async onRowClick(...args) {
    console.log(args);
    if (!args[0]?.item?.shortId) return;
    await this.setAsyncState({ visibleModal: null, modalData: null });

    navigationModule.addQuery(
      {
        sid: args[0].item.shortId,
      },
      this.props.navigate
    );
  }

  render() {
    const {
      state: {
        visibleModal,
        modalData,
        triggerReload,
        triggerLoadMore,
        additionalFilter,
      },
    } = this;

    const selectedAccountShortId = navigationModule.getQuery("sid");

    const screen = (
      <div>
        <div className="pagetitlebar">
          <div className="left">
            <div className="title">Accounts</div>
          </div>
          <div className="right">
            <ButtonToolbar>
              <ToggleButtonGroup
                value={
                  !additionalFilter?.accountType
                    ? ["all"]
                    : [additionalFilter?.accountType]
                }
                onChange={(value) =>
                  this.setAdditionalFilter(
                    "accountType",
                    value === "all" ? undefined : value
                  )
                }
                type="radio"
                name="accountType"
              >
                {[
                  { name: "All", value: "all" },
                  { name: "Loan", value: "loan" },
                  { name: "Deposit", value: "deposit" },
                ].map((radio, idx) => (
                  <ToggleButton
                    key={idx + "accountType"}
                    id={`account-accountType-filter-radio-${idx}`}
                    variant={"outline-success"}
                    name={radio.name}
                    value={radio.value}
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
              <div className="m-1"/>
              <ButtonGroup>
                {[
                  { name: "All", value: "all" },
                  { name: "Open", value: "open" },
                  { name: "Closed", value: "closed" },
                ].map((radio, idx) => (
                  <ToggleButton
                    key={idx + "status"}
                    id={`account-status-filter-radio-${idx}`}
                    type="radio"
                    variant={"outline-success"}
                    name="radio"
                    value={radio.value}
                    checked={
                      (additionalFilter?.closed === undefined
                        ? "all"
                        : additionalFilter?.closed
                        ? "closed"
                        : "open") === radio.value
                    }
                    onChange={({ target: { value } }) =>
                      this.setAdditionalFilter(
                        "closed",
                        value === "open"
                          ? false
                          : value === "closed"
                          ? true
                          : undefined
                      )
                    }
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </ButtonGroup>
            </ButtonToolbar>
            <div className="m-1" />
            <SearchBox
              onChange={this.searchAccountId.bind(this)}
              onSubmitOnly
              placeholder="Enter Account ID"
            />
             <SearchBox
              onChange={this.handleSearchQ.bind(this)}
              placeholder="Search Customer"
            />
            <Button
              onClick={() =>
                this.setAsyncState({
                  visibleModal: "editAccount",
                  modalData: null,
                })
              }
            >
              Add New Account
            </Button>
          </div>
        </div>

        <div>
          <ItemList
            {...{
              defaultQuery: { populate: "customer", limit: 100 },
              triggerReload,
              triggerLoadMore,
              items: this.props.accounts,
              table: {
                columns: this.columns,
                onRowClick: this.onRowClick.bind(this),
              },
              retriveData: this.retriveData.bind(this),
              setItems: this.setItems.bind(this),
              additionalQueries: {
                ...(this.additionalQueries || {}),
                where: {
                  ...(this.additionalQueries?.where || {}),
                  ...(additionalFilter || {}),
                },
              },
            }}
          />
        </div>

        <EditAccount
          {...{
            key: `editAccount-${
              visibleModal === "editAccount"
                ? modalData?.account?._id?.toString() || "new"
                : "disabled"
            }`,

            triggerReload,
            renderModal: true,
            visible: visibleModal === "editAccount",

            handleClose: () => this.setAsyncState({ visibleModal: null }),
            onSubmit: (item) => this.onNewAccount(item),
            accounts: this.props.accounts,
            ...(modalData || {}),
          }}
        />

        <AccountDetails
          {...{
            key: `accountDetails-${
              !visibleModal && !!selectedAccountShortId
                ? selectedAccountShortId
                : "disabled"
            }`,

            renderModal: true,
            visible: !visibleModal && !!selectedAccountShortId,
            shortId: selectedAccountShortId,

            handleClose: () =>
              navigationModule.removeQuery(["sid"], this.props.navigate),
            ...(modalData || {}),
          }}
        />
        <PrintCustomerReceipt
          {...{
            key: `customerReceipt-${
              visibleModal === "customerReceipt"
                ? modalData?.account?._id?.toString() || "null"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "customerReceipt",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            accounts: this.props.accounts,
            loadMore: () => this.setAsyncState({ triggerLoadMore: Date.now() }),
            multipleAccounts: true,
            ...(modalData || {}),
          }}
        />
      </div>
    );

    return (
      <>
        <NavBar activeLink="/account" />
        <Container className="gainner">{screen}</Container>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  accounts: state.vState[SCREEN_NAME]?.accounts || [],
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AccountsScreen));
